import { License } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import Padlock from '../../assets/icons/padlock.svg';
import PayPalLogo from '../../assets/logos/paypal.svg';
import { CardType } from '../../types/cardType';

import {
  TXTSRV_Resorts_Casino,
  TXTWCL_Let_us_know_your_CPF,
  TXTWCL_Let_us_know_your_N0_voucher_PI_ELL,
  TXTWCL_Let_us_know_your_email_address,
  TXTWCL_Let_us_know_your_mobile_number,
  TXTWCL_PayPal_Instant_Payments_are_he_ELL,
  TXTWCL_Please_add_your_card_details,
  TXTWCL_Please_confirm_your_bank_accou_ELL,
  TXTWCL_Please_confirm_your_payment_de_ELL,
  TXTWCL_Please_enter_your_PokerStars_R_ELL,
  TXTWCL_Please_enter_your_PokerStars_T_ELL,
  TXTWCL_Please_enter_your_Ricarica_Cas_ELL,
  TXTWCL_Please_enter_your_bank_account_ELL_1,
  TXTWCL_Please_enter_your_details_for__ELL,
  TXTWCL_Please_provide_your_account_de_ELL,
  TXTWCL_Please_select_a_bank,
  TXTWCL_Vanilla_Direct_1,
  TXTWCL_We_keep_your_data_safe,
  TXTWCL_WhatXs_your_phone_numberX
} from './PaymentTitles.messages.json';
import { logo, secure } from './PaymentTitles.scss';

interface Props {
  savedCardInfoId?: number;
  showSafeInfo: boolean;
  systemName: string;
  type: CardType;
  useConfirmTitle?: boolean;
}

const getConfirmTitle = (type: CardType) => {
  const subtitles = {
    [CardType.ECheck]: TXTWCL_Please_confirm_your_bank_accou_ELL
  };

  return subtitles[type];
};

const getTitle = (type: CardType, license: License, savedCardInfoId?: number) => {
  const subtitles = {
    [CardType.AstropayWallet]: TXTWCL_Let_us_know_your_mobile_number,
    [CardType.BoletoAstropay]: TXTWCL_Let_us_know_your_CPF,
    [CardType.DBT]: TXTWCL_Please_provide_your_account_de_ELL,
    [CardType.ECheck]: TXTWCL_Please_enter_your_bank_account_ELL_1,
    [CardType.EnvoyLbt]: TXTWCL_Please_select_a_bank,
    [CardType.Interac]: TXTWCL_WhatXs_your_phone_numberX,
    [CardType.LuxonPay]: TXTWCL_Let_us_know_your_email_address,
    [CardType.MBookers]: TXTWCL_Let_us_know_your_email_address,
    [CardType.MuchBetter]: TXTWCL_Let_us_know_your_mobile_number,
    [CardType.Neosurf]: TXTWCL_Let_us_know_your_N0_voucher_PI_ELL,
    [CardType.Neteller2]: TXTWCL_Let_us_know_your_email_address,
    [CardType.PStarsTopUp]: TXTWCL_Please_enter_your_PokerStars_T_ELL,
    [CardType.PayPal]: TXTWCL_PayPal_Instant_Payments_are_he_ELL,
    [CardType.Pay4Fun]: TXTWCL_Let_us_know_your_email_address,
    [CardType.Pix]: TXTWCL_Let_us_know_your_CPF,
    [CardType.PsPayAstropay]: TXTWCL_Please_enter_your_details_for__ELL,
    [CardType.PsPayInovapay]: TXTWCL_Please_enter_your_details_for__ELL,
    [CardType.VanillaDirect]: TXTWCL_Vanilla_Direct_1,
    [CardType.Ricarica]:
      license === License.ES
        ? TXTWCL_Please_enter_your_PokerStars_R_ELL
        : TXTWCL_Please_enter_your_Ricarica_Cas_ELL,
    [CardType.Skrill1Tap]: TXTWCL_Let_us_know_your_email_address,
    [CardType.WireCashout]: TXTWCL_Please_provide_your_account_de_ELL,
    [CardType.Resort]: TXTSRV_Resorts_Casino,
    [CardType.OpenBanking]: {
      id: '*',
      defaultMessage: '{0}'
    }
  };

  return (
    (savedCardInfoId && TXTWCL_Please_confirm_your_payment_de_ELL) ||
    subtitles[type] ||
    TXTWCL_Please_add_your_card_details
  );
};

const PaymentTitles: React.FC<Props> = ({
  savedCardInfoId,
  showSafeInfo,
  systemName,
  type,
  useConfirmTitle
}) => {
  const license = useSelector(select.account.getLicense);

  return (
    <>
      {type === CardType.PayPal && (
        <div className={logo}>
          <PayPalLogo />
        </div>
      )}
      <Translation
        {...(useConfirmTitle ? getConfirmTitle(type) : getTitle(type, license, savedCardInfoId))}
        tagName="h2"
        values={{ 0: systemName }}
      />
      {showSafeInfo ? (
        <div className={secure}>
          <Padlock />
          <Translation tagName="h3" {...TXTWCL_We_keep_your_data_safe} />
        </div>
      ) : null}
    </>
  );
};

export default PaymentTitles;
